import { initializeConnector } from "@web3-react/core";
import { WalletConnect } from "@web3-react/walletconnect-v2";
import { getEnv } from "@bkry/bowline-utils";
import { CHAINS } from "./chains";

const chains = Object.keys(CHAINS).map(Number);

export const [walletConnect, hooks] = initializeConnector((actions) => {
  return new WalletConnect({
    actions,
    defaultChainId: 1,
    options: {
      projectId: getEnv("REACT_APP_WALLET_CONNECT_PROJECT_ID"),
      chains,
      optionalChains: chains,
      showQrModal: true,
      qrModalOptions: {
        themeVariables: {
          "--wcm-z-index": "9999999",
        },
      },
    },
  });
});
